import { useLayoutContext } from "client/components/layout"
import { ProductHeaderBase } from "client/packages/commerce/components/product/ProductHeader"
import {
  Plugin,
  useGlobalContext,
} from "client/packages/utils/GlobalContext"
import { RozyLayout } from "shared/constants/views"

import {
  getCartTotalItemCount,
  useTargetCartContext,
} from "./cart/TargetCartContext"

export default function ProductHeader({
  showCart,
}: {
  showCart: () => void
}) {
  const { setPluginOpen } = useGlobalContext()
  const { contents } = useTargetCartContext()
  const { layout } = useLayoutContext()

  const isPanelClosable =
    layout === RozyLayout.DESKTOP || layout === RozyLayout.MOBILE

  return (
    <ProductHeaderBase
      showCart={showCart}
      numItemsInCart={getCartTotalItemCount(contents)}
      onClose={
        isPanelClosable
          ? () => {
              setPluginOpen(Plugin.TARGET, false)
            }
          : null
      }
    />
  )
}
